import React, { useEffect, useState } from "react";
import { Table, Card, Button } from "react-bootstrap";
import { useGroupScorecardPlayer, usePlayerNameByEntryId } from "../util/db";
import ScorecardSummaryCell from "./ScorecardSummaryCell";
import ShareModal from "./ShareModal";
import useShareCard from "./useShareCard";

function displayThrowScoreStats(holes) {
  // Initialize counters
  const throwScoreCounts = {
    0: 0, // 🚫 Miss
    1: 0, // ⛓️ Metal Hit
    2: 0, // ✔️ In Basket
  };

  // Check if holes exists and is an array before processing
  if (!holes || !Array.isArray(holes)) {
    return null;
  }

  // Count each throw score
  holes.forEach((hole) => {
    if (hole.throw_scores && Array.isArray(hole.throw_scores)) {
      hole.throw_scores.forEach((throwScore) => {
        if (
          throwScore.throw_score !== undefined &&
          throwScore.throw_score !== null
        ) {
          throwScoreCounts[throwScore.throw_score]++;
        }
      });
    }
  });

  // Get screen width for responsive design
  const screenWidth = typeof window !== "undefined" ? window.innerWidth : 768;
  const isMobile = screenWidth < 768;
  const isSmallMobile = screenWidth < 576;

  // Return JSX to display the statistics with enhanced modern styling
  return (
    <div
      style={{
        fontSize: isSmallMobile ? "9px" : isMobile ? "10px" : "11px",
        padding: isSmallMobile ? "6px" : isMobile ? "8px" : "16px",
        backgroundColor: "rgba(248, 249, 250, 0.95)",
        borderRadius: isSmallMobile ? "10px" : isMobile ? "12px" : "14px",
        border: "1px solid rgba(45, 8, 63, 0.12)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        boxShadow:
          "0 3px 12px rgba(45, 8, 63, 0.1), 0 1px 4px rgba(45, 8, 63, 0.06)",
        background:
          "linear-gradient(135deg, rgba(248, 249, 250, 0.98) 0%, rgba(255, 255, 255, 0.9) 100%)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          fontWeight: "800",
          marginBottom: isSmallMobile ? "4px" : isMobile ? "6px" : "12px",
          color: "#2D083F",
          fontSize: isSmallMobile ? "8px" : isMobile ? "9px" : "12px",
          textTransform: "uppercase",
          letterSpacing: isSmallMobile ? "0.5px" : isMobile ? "0.8px" : "1.2px",
          textAlign: "center",
          textShadow: "0 1px 3px rgba(45, 8, 63, 0.2)",
          opacity: 0.85,
          whiteSpace: "nowrap",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isSmallMobile ? "Stats" : "Throw Stats"}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isSmallMobile ? "3px" : isMobile ? "4px" : "8px",
          alignItems: "center",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: isSmallMobile ? "10px" : isMobile ? "11px" : "14px",
            fontWeight: "700",
            color: "#2D083F",
            width: "100%",
            maxWidth: isSmallMobile ? "60px" : isMobile ? "70px" : "80px",
            padding: isSmallMobile
              ? "3px 4px"
              : isMobile
              ? "4px 5px"
              : "7px 9px",
            borderRadius: isSmallMobile ? "8px" : isMobile ? "9px" : "12px",
            backgroundColor: "rgba(40, 167, 69, 0.08)",
            border: "1px solid rgba(40, 167, 69, 0.2)",
          }}
        >
          <span
            style={{
              marginRight: isSmallMobile ? "3px" : "6px",
              fontSize: isSmallMobile ? "12px" : isMobile ? "14px" : "17px",
              width: isSmallMobile ? "12px" : isMobile ? "16px" : "19px",
              textAlign: "center",
              display: "inline-block",
              filter: "drop-shadow(0 1px 2px rgba(40, 167, 69, 0.3))",
              flexShrink: 0,
            }}
          >
            ✔️
          </span>
          <span
            style={{
              backgroundColor: "#28a745",
              color: "white",
              borderRadius: isSmallMobile ? "6px" : isMobile ? "8px" : "11px",
              padding: isSmallMobile
                ? "2px 6px"
                : isMobile
                ? "3px 8px"
                : "6px 12px",
              fontSize: isSmallMobile ? "9px" : isMobile ? "10px" : "13px",
              fontWeight: "800",
              minWidth: isSmallMobile ? "26px" : isMobile ? "30px" : "38px",
              textAlign: "center",
              boxShadow:
                "0 3px 6px rgba(40, 167, 69, 0.35), 0 1px 3px rgba(40, 167, 69, 0.25)",
              textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {throwScoreCounts[2]}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: isSmallMobile ? "10px" : isMobile ? "11px" : "14px",
            fontWeight: "700",
            color: "#2D083F",
            width: "100%",
            maxWidth: isSmallMobile ? "60px" : isMobile ? "70px" : "80px",
            padding: isSmallMobile
              ? "3px 4px"
              : isMobile
              ? "4px 5px"
              : "7px 9px",
            borderRadius: isSmallMobile ? "8px" : isMobile ? "9px" : "12px",
            backgroundColor: "rgba(255, 193, 7, 0.08)",
            border: "1px solid rgba(255, 193, 7, 0.2)",
          }}
        >
          <span
            style={{
              marginRight: isSmallMobile ? "3px" : "6px",
              fontSize: isSmallMobile ? "12px" : isMobile ? "14px" : "17px",
              width: isSmallMobile ? "12px" : isMobile ? "16px" : "19px",
              textAlign: "center",
              display: "inline-block",
              filter: "drop-shadow(0 1px 2px rgba(255, 193, 7, 0.3))",
              flexShrink: 0,
            }}
          >
            ⛓️
          </span>
          <span
            style={{
              backgroundColor: "#ffc107",
              color: "#1a1a1a",
              borderRadius: isSmallMobile ? "6px" : isMobile ? "8px" : "11px",
              padding: isSmallMobile
                ? "2px 6px"
                : isMobile
                ? "3px 8px"
                : "6px 12px",
              fontSize: isSmallMobile ? "9px" : isMobile ? "10px" : "13px",
              fontWeight: "800",
              minWidth: isSmallMobile ? "26px" : isMobile ? "30px" : "38px",
              textAlign: "center",
              boxShadow:
                "0 3px 6px rgba(255, 193, 7, 0.35), 0 1px 3px rgba(255, 193, 7, 0.25)",
              textShadow: "0 1px 2px rgba(0, 0, 0, 0.15)",
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {throwScoreCounts[1]}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: isSmallMobile ? "10px" : isMobile ? "11px" : "14px",
            fontWeight: "700",
            color: "#2D083F",
            width: "100%",
            maxWidth: isSmallMobile ? "60px" : isMobile ? "70px" : "80px",
            padding: isSmallMobile
              ? "3px 4px"
              : isMobile
              ? "4px 5px"
              : "7px 9px",
            borderRadius: isSmallMobile ? "8px" : isMobile ? "9px" : "12px",
            backgroundColor: "rgba(220, 53, 69, 0.08)",
            border: "1px solid rgba(220, 53, 69, 0.2)",
          }}
        >
          <span
            style={{
              marginRight: isSmallMobile ? "3px" : "6px",
              fontSize: isSmallMobile ? "12px" : isMobile ? "14px" : "17px",
              width: isSmallMobile ? "12px" : isMobile ? "16px" : "19px",
              textAlign: "center",
              display: "inline-block",
              filter: "drop-shadow(0 1px 2px rgba(220, 53, 69, 0.3))",
              flexShrink: 0,
            }}
          >
            🚫
          </span>
          <span
            style={{
              backgroundColor: "#dc3545",
              color: "white",
              borderRadius: isSmallMobile ? "6px" : isMobile ? "8px" : "11px",
              padding: isSmallMobile
                ? "2px 6px"
                : isMobile
                ? "3px 8px"
                : "6px 12px",
              fontSize: isSmallMobile ? "9px" : isMobile ? "10px" : "13px",
              fontWeight: "800",
              minWidth: isSmallMobile ? "26px" : isMobile ? "30px" : "38px",
              textAlign: "center",
              boxShadow:
                "0 3px 6px rgba(220, 53, 69, 0.35), 0 1px 3px rgba(220, 53, 69, 0.25)",
              textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {throwScoreCounts[0]}
          </span>
        </div>
      </div>
    </div>
  );
}

function ScorecardSummaryTable5x4({ eventEntryId, throwScoringModeId }) {
  const { data: holes } = useGroupScorecardPlayer(eventEntryId);
  const { data: playerData } = usePlayerNameByEntryId(eventEntryId);
  const [holeScores, setHoleScores] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPlus, setTotalPlus] = useState(0);

  // Extract player name from the nested data structure
  const playerName = playerData?.[0]?.users_public?.name;

  // Extract event name from the nested data structure
  const eventName = playerData?.[0]?.events?.name;

  // Use the share card hook
  const {
    showShareModal,
    setShowShareModal,
    handleShare,
    handleDownloadImage,
  } = useShareCard();

  // Mobile responsiveness state
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 768
  );

  const isMobile = screenWidth < 768;
  const isSmallMobile = screenWidth < 576;

  // Calculate throw stats for sharing
  const calculateShareStats = () => {
    const throwScoreCounts = { 0: 0, 1: 0, 2: 0 };
    let totalThrows = 0;

    if (holes && Array.isArray(holes)) {
      holes.forEach((hole) => {
        if (hole.throw_scores && Array.isArray(hole.throw_scores)) {
          hole.throw_scores.forEach((throwScore) => {
            if (
              throwScore.throw_score !== undefined &&
              throwScore.throw_score !== null
            ) {
              throwScoreCounts[throwScore.throw_score]++;
              totalThrows++;
            }
          });
        }
      });
    }

    const makeRate =
      totalThrows > 0 ? (throwScoreCounts[2] / totalThrows) * 100 : 0;
    return { throwScoreCounts, totalThrows, makeRate };
  };

  // Check if scorecard is completed
  const isCompletedRound = () => {
    if (!holes || !Array.isArray(holes) || holes.length === 0) return false;

    // Check if all holes have scores
    return holes.every(
      (hole) =>
        hole.score !== null && hole.score !== undefined && hole.score > 0
    );
  };

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== "undefined") {
        setScreenWidth(window.innerWidth);
      }
    };

    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  let maxHole = holes?.length ? holes.length : 0;
  const columns = maxHole === 20 ? 4 : maxHole === 10 ? 5 : 4;

  // Calculate column spans for proportional layout
  // Ensure minimum 2 columns for proper layout (1 for total, 1 for stats)
  const minColumns = Math.max(columns, 2);

  const totalScoreColSpan =
    minColumns % 2 === 0
      ? Math.floor(minColumns / 2) // Even columns: 50/50 split
      : Math.ceil(minColumns / 2); // Odd columns: total score gets 1 more column

  const throwStatsColSpan = minColumns - totalScoreColSpan;

  useEffect(() => {
    if (holes) {
      const scores = [];
      let scores_total = 0;
      let scores_total_plus = 0;
      holes.forEach((hole) => {
        let throwOneScore = hole.throw_scores?.find(
          (throw_score) => throw_score.throw_number === 1
        )?.throw_score;

        let throwTwoScore = hole.throw_scores?.find(
          (throw_score) => throw_score.throw_number === 2
        )?.throw_score;

        // Apply fallback only if throwOneScore or throwTwoScore is undefined
        throwOneScore = throwOneScore !== undefined ? throwOneScore : 0;
        throwTwoScore = throwTwoScore !== undefined ? throwTwoScore : 0;

        scores.push({
          hole_order: hole.layout_holes.hole_order,
          score: hole.score,
          hole_score_adv: hole.hole_score_adv,
          throw_one_score: throwOneScore,
          throw_two_score: throwTwoScore,
        });
        scores_total += hole.score;
        scores_total_plus += hole.hole_score_adv;
      });

      scores.sort((a, b) => a.hole_order - b.hole_order);

      setHoleScores(scores);
      setTotal(scores_total);
      setTotalPlus(scores_total_plus);
    }
  }, [holes]);
  return (
    <>
      <Card
        style={{
          boxShadow: isMobile
            ? "0 4px 16px rgba(45, 8, 63, 0.12), 0 2px 8px rgba(45, 8, 63, 0.08)"
            : "0 8px 24px rgba(45, 8, 63, 0.15), 0 4px 12px rgba(45, 8, 63, 0.1), 0 2px 6px rgba(45, 8, 63, 0.08)",
          border: "none",
          borderRadius: isSmallMobile ? "12px" : isMobile ? "16px" : "20px",
          overflow: "hidden",
          background:
            "linear-gradient(135deg, #ffffff 0%, rgba(248, 249, 250, 0.9) 100%)",
          position: "relative",
          transition: "all 0.3s ease",
        }}
      >
        {/* Enhanced top accent border */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: isSmallMobile ? "3px" : "4px",
            background:
              "linear-gradient(90deg, rgba(45, 8, 63, 0.9) 0%, rgba(45, 8, 63, 0.7) 30%, rgba(45, 8, 63, 0.5) 50%, rgba(45, 8, 63, 0.7) 70%, rgba(45, 8, 63, 0.9) 100%)",
            borderRadius: `${
              isSmallMobile ? "12px" : isMobile ? "16px" : "20px"
            } ${isSmallMobile ? "12px" : isMobile ? "16px" : "20px"} 0 0`,
            boxShadow: "0 1px 3px rgba(45, 8, 63, 0.3)",
          }}
        />

        <Card.Body
          style={{
            padding: isSmallMobile ? "12px" : isMobile ? "16px" : "20px",
            backgroundColor: "transparent",
          }}
        >
          <Table
            responsive
            bordered
            style={{
              tableLayout: "fixed",
              border: `${isMobile ? "3px" : "4px"} solid #2D083F`,
              marginBottom: "0",
              fontSize: isSmallMobile ? "12px" : isMobile ? "14px" : "16px",
              borderRadius: isSmallMobile ? "8px" : isMobile ? "10px" : "12px",
              overflow: "hidden",
              backgroundColor: "#ffffff",
              boxShadow: "inset 0 1px 3px rgba(45, 8, 63, 0.08)",
            }}
          >
            <tbody>
              {[...Array(5)].map((_, rowIndex) => (
                <tr
                  key={rowIndex}
                  style={{
                    borderBottom:
                      rowIndex < 4 ? `1px dotted rgba(45, 8, 63, 0.4)` : "none",
                    backgroundColor:
                      rowIndex % 2 === 0
                        ? "rgba(248, 249, 250, 0.3)"
                        : "transparent",
                    transition: "background-color 0.2s ease",
                  }}
                >
                  {holeScores
                    .slice(rowIndex * columns, rowIndex * columns + columns)
                    .map((hole, cellIndex) => (
                      <ScorecardSummaryCell
                        key={cellIndex}
                        hole={hole}
                        index={rowIndex * columns + cellIndex}
                        throwScoringModeId={throwScoringModeId}
                        maxHole={maxHole}
                      />
                    ))}
                </tr>
              ))}

              {/* Enhanced Summary Row with Stats and Total */}
              <tr
                style={{
                  borderTop: `${isMobile ? "3px" : "4px"} solid #2D083F`,
                  backgroundColor: "rgba(248, 249, 250, 0.2)",
                }}
              >
                {/* Total Score Cell - Enhanced with modern styling */}
                <td
                  colSpan={totalScoreColSpan}
                  className="text-center align-middle"
                  style={{
                    position: "relative",
                    fontSize: isSmallMobile
                      ? "32px"
                      : isMobile
                      ? "36px"
                      : "40px",
                    fontWeight: "900",
                    color: "#2D083F",
                    backgroundColor: "#ffffff",
                    background: isMobile
                      ? "linear-gradient(135deg, rgba(45, 8, 63, 0.03) 0%, rgba(248, 249, 250, 0.95) 100%)"
                      : "linear-gradient(135deg, rgba(45, 8, 63, 0.025) 0%, rgba(248, 249, 250, 0.9) 30%, #ffffff 70%, rgba(240, 242, 247, 0.8) 100%)",
                    padding: isSmallMobile
                      ? "22px 15px"
                      : isMobile
                      ? "28px 18px"
                      : "32px 24px",
                    border: `${isMobile ? "3px" : "4px"} solid #2D083F`,
                    borderRadius: isSmallMobile
                      ? "10px"
                      : isMobile
                      ? "12px"
                      : "14px",
                    boxShadow: isMobile
                      ? "inset 0 2px 6px rgba(45, 8, 63, 0.06), 0 3px 12px rgba(45, 8, 63, 0.15), 0 1px 3px rgba(45, 8, 63, 0.1)"
                      : "inset 0 3px 8px rgba(45, 8, 63, 0.08), 0 6px 20px rgba(45, 8, 63, 0.12), 0 2px 6px rgba(45, 8, 63, 0.08)",
                  }}
                >
                  {/* Enhanced Total label with better typography */}
                  <div
                    style={{
                      fontSize: isSmallMobile
                        ? "14px"
                        : isMobile
                        ? "16px"
                        : "19px",
                      fontWeight: "900",
                      color: "#2D083F",
                      marginBottom: isSmallMobile
                        ? "10px"
                        : isMobile
                        ? "12px"
                        : "14px",
                      textTransform: "uppercase",
                      letterSpacing: isSmallMobile
                        ? "1.2px"
                        : isMobile
                        ? "1.5px"
                        : "1.8px",
                      textShadow:
                        "0 2px 4px rgba(45, 8, 63, 0.2), 0 1px 2px rgba(45, 8, 63, 0.1)",
                      opacity: 0.9,
                      fontFamily: "system-ui, -apple-system, sans-serif",
                    }}
                  >
                    TOTAL SCORE
                  </div>

                  {/* Enhanced main total display with improved contrast */}
                  <div
                    style={{
                      fontSize: isSmallMobile
                        ? "46px"
                        : isMobile
                        ? "54px"
                        : "62px",
                      fontWeight: "900",
                      textShadow:
                        "0 4px 8px rgba(45, 8, 63, 0.25), 0 2px 4px rgba(45, 8, 63, 0.15), 0 1px 2px rgba(45, 8, 63, 0.1)",
                      lineHeight: "0.85",
                      color: "#2D083F",
                      marginBottom: "6px",
                      filter: "drop-shadow(0 2px 4px rgba(45, 8, 63, 0.15))",
                      fontFamily: "system-ui, -apple-system, sans-serif",
                    }}
                  >
                    {throwScoringModeId > 1 ? totalPlus : total}
                  </div>

                  {/* Enhanced secondary score display with improved typography */}
                  {throwScoringModeId > 1 && (
                    <div
                      style={{
                        position: "absolute",
                        top: isSmallMobile ? "12px" : "14px",
                        left: isSmallMobile ? "12px" : "14px",
                        fontSize: isSmallMobile ? "12px" : "14px",
                        background:
                          "linear-gradient(135deg, rgba(45, 8, 63, 0.98) 0%, rgba(45, 8, 63, 0.9) 100%)",
                        color: "white",
                        padding: isSmallMobile ? "8px 11px" : "10px 13px",
                        borderRadius: isMobile ? "9px" : "11px",
                        fontWeight: "800",
                        backdropFilter: "blur(12px)",
                        boxShadow:
                          "0 4px 16px rgba(45, 8, 63, 0.35), 0 2px 6px rgba(45, 8, 63, 0.25)",
                        border: "1px solid rgba(255, 255, 255, 0.15)",
                        textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
                        fontFamily: "system-ui, -apple-system, sans-serif",
                      }}
                    >
                      Base: {total}
                    </div>
                  )}
                </td>
                {/* Enhanced Throw Statistics Cell - Maintains proportional layout */}
                <td
                  colSpan={throwStatsColSpan}
                  style={{
                    verticalAlign: "middle",
                    padding: isSmallMobile ? "8px" : isMobile ? "10px" : "12px",
                    backgroundColor: "rgba(248, 249, 250, 0.4)",
                    border: `${
                      isMobile ? "2px" : "3px"
                    } solid rgba(45, 8, 63, 0.15)`,
                    borderRadius: isSmallMobile
                      ? "10px"
                      : isMobile
                      ? "12px"
                      : "14px",
                    boxShadow:
                      "0 2px 8px rgba(45, 8, 63, 0.08), 0 1px 3px rgba(45, 8, 63, 0.04)",
                    background:
                      "linear-gradient(135deg, rgba(248, 249, 250, 0.6) 0%, rgba(255, 255, 255, 0.3) 100%)",
                  }}
                >
                  {displayThrowScoreStats(holes)}
                </td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>

        {/* Share Button - Only show for completed rounds */}
        {isCompletedRound() && (
          <Card.Footer
            className="text-center"
            style={{ backgroundColor: "#f8f9fa", border: "none" }}
          >
            <Button
              variant="primary"
              onClick={handleShare}
              style={{
                backgroundColor: "#2D083F",
                borderColor: "#2D083F",
                fontWeight: "600",
                padding: "8px 16px",
                borderRadius: "8px",
              }}
            >
              📤 Share Scorecard
            </Button>
          </Card.Footer>
        )}
      </Card>

      {/* Share Modal */}
      <ShareModal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        total={total}
        totalPlus={totalPlus}
        throwScoringModeId={throwScoringModeId}
        calculateShareStats={calculateShareStats}
        onDownload={handleDownloadImage}
        playerName={playerName}
        eventName={eventName}
      />
    </>
  );
}

export default ScorecardSummaryTable5x4;
